import Blog from "components/blogComponent/Blog";
const BlogPage = () => {
  return (
    <div>
      <Blog />
    </div>
  );
};

export default BlogPage;
